import { add, endOf, parseDate, startOf } from 'helpers/date_utils';

import { dateGroups } from 'bundles/apex/deals/show/planner/config';

export function getAssignees(deal) {
  const tasks = getTasks(deal);
  const assignees = [];
  tasks.forEach((task) => {
    if (task.record.assignee && !assignees.find(assignee => assignee.id === task.record.assignee.id)) {
      assignees.push(task.record.assignee);
    }
  });

  return ([
    { id: '', name: 'All Assignees' },
    ...assignees.sort((a, b) => a.name.localeCompare(b.name)),
  ]);
}

export function getSortedTasks(deal) {
  const tasks = getTasks(deal);
  return sortTasksAndDates(tasks).map(({ record }) => record);
}

export function getGroupedTasksAndDates(deal, fields, filters) {
  let tasksAndDates = getTasks(deal).concat(getDates(deal, fields));
  tasksAndDates = filterTasksAndDates(tasksAndDates, fields, filters);
  tasksAndDates = sortTasksAndDates(tasksAndDates);

  const groupedItems = groupTasksAndDates(tasksAndDates, (internalItem) => {
    const item = {
      record: internalItem.record,
      type: internalItem.type,
    };

    if (internalItem.type === 'date') {
      item.name = internalItem.name;
    }

    return item;
  });

  return groupedItems;
}

export function getTasks(deal) {
  return deal.tasks.map(task => ({
    date: task.deadline?.date || null,
    record: task,
    type: 'task',
  }));
}

function getDates(deal, fields) {
  const dates = [];

  for (const name in deal) {
    const value = deal[name];
    const field = fields[name];

    if ((field && field.isDate) || (value && value.adHoc)) {
      dates.push({
        date: value.date,
        name,
        record: value,
        type: 'date',
      });
    }
  }

  return dates;
}

function sortTasksAndDates(items) {
  return items.sort((a, b) => {
    if (a.date == b.date) {
      return a.record.id - b.record.id;
    } else if (!b.date || a.date > b.date) {
      return 1;
    } else {
      return -1;
    }
  });
}

export function groupTasksAndDates(items, itemTransformation) {
  const today = startOf(new Date(), 'day');
  const saturday = add(endOf(new Date(), 'day'), 6 - new Date().getDay(), 'days');
  const groupedItems = {};
  Object.keys(dateGroups).forEach(groupKey => groupedItems[groupKey] = []);

  items.forEach((item) => {
    const itemDate = parseDate(item.date);
    let transformedItem = item;
    if (itemTransformation) {
      transformedItem = itemTransformation(item);
    }

    if (!item.date || itemDate > saturday) {
      groupedItems.future.push(transformedItem);
    } else if (itemDate < today) {
      groupedItems.past.push(transformedItem);
    } else if (itemDate.getTime() === today.getTime()) {
      groupedItems.today.push(transformedItem);
    } else {
      groupedItems.thisWeek.push(transformedItem);
    }
  });

  return groupedItems;
}

export function filterTasksAndDates(items, fields, filters) {
  const today = startOf(new Date(), 'day');

  return items.filter((item) => {
    const itemDate = parseDate(item.date);
    const overdue = item.date && itemDate < today;

    if (!filters.criticalDate && item.type === 'date') {
      return false;
    }
    if (!filters.completed && item.type === 'task' && item.record.completed) {
      return false;
    }
    if (!filters.overdue && item.type === 'task' && !item.record.completed && overdue) {
      return false;
    }
    if (!filters.open && item.type === 'task' && !item.record.completed && !overdue) {
      return false;
    }

    if (filters.required && item.type === 'task' && !item.record.required) {
      return false;
    }

    if (item.type === 'date' && !item.date && item.record.static && !fields[item.name]?.required) {
      return false;
    }

    if (
      item.type === 'task' &&
      filters.selectedAssigneeId &&
      filters.selectedAssigneeId != item.record.assignee?.id
    ) {
      return false;
    }

    return true;
  });
}
